import { render, staticRenderFns } from "./editSigningRules.vue?vue&type=template&id=4b2d8c87&scoped=true&"
import script from "./editSigningRules.vue?vue&type=script&lang=js&"
export * from "./editSigningRules.vue?vue&type=script&lang=js&"
import style0 from "./editSigningRules.vue?vue&type=style&index=0&id=4b2d8c87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d8c87",
  null
  
)

export default component.exports